import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import {
  loginUserCheck,
  logoutUser,
  userFetchById,
  userUpdate,
} from "../redux/actions";

class AdminEditUser extends Component {
  constructor() {
    super();
    this.state = {
      rank: "",
      user_id: "",
      firstname: "",
      lastname: "",
      id: "",
      toggleMenu: false,
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    let params = this.getParams(this.props.location);
    this.props.userFetchById(params.id);
    this.setState({ id: params.id });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      this.setState({
        rank: nextProps.user.rank,
        user_id: nextProps.user.user_id,
        firstname: nextProps.user.firstname,
        lastname: nextProps.user.lastname,
      });
    }
  }

  getParams(location) {
    const searchParams = new URLSearchParams(location.search);
    return {
      id: searchParams.get("id") || "",
    };
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  _onSubmit() {
    let user = {
      rank: this.state.rank,
      user_id: this.state.user_id,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
    };
    if (this.state.firstname && this.state.lastname) {
      this.props.userUpdate(this.state.id, user);
    } else {
      alert("Please fill in a form...");
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.admin} logout={() => this._handleLogout()} />
        <div className="admin-adduser">
          <Nav active="users" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>ลูกค้า : แก้ไขชื่อลูกค้า</h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <div className="name">
                    <form>
                      <div className="type">
                        <p>ระดับลูกค้า</p>
                        <select
                          name="rank"
                          onChange={(event) => this._onHandleChange(event)}
                          value={this.state.rank}
                        >
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                        </select>
                      </div>
                      <p>User ID</p>
                      <input
                        type="text"
                        name="user_id"
                        onChange={(event) => this._onHandleChange(event)}
                        value={this.state.user_id}
                      ></input>
                      <p>ชื่อ</p>
                      <input
                        type="text"
                        name="firstname"
                        onChange={(event) => this._onHandleChange(event)}
                        value={this.state.firstname}
                      ></input>
                      <p>นามสกุล</p>
                      <input
                        type="text"
                        name="lastname"
                        onChange={(event) => this._onHandleChange(event)}
                        value={this.state.lastname}
                      ></input>
                    </form>
                  </div>
                  <div className="action-button">
                    <Button type="primary" onClick={() => this._onSubmit()}>
                      บันทึก
                    </Button>
                    <Button onClick={() => window.history.back()}>กลับ</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, user }) => {
  return {
    admin: auth.user,
    user: user.user,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  userFetchById,
  userUpdate,
})(AdminEditUser);
